import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import SearchResultPage from '../pages/SearchResultPage';
import FlightDetailPage from '../pages/FlightDetailPage';
import FlightConfirmDetailPage from '../pages/FlightConfirmDetailPage';
import SearchResultRoundtripPage from '../pages/SearchResultRoundtripPage';
import Layout from './resuableComponents/Layout';
import SearchResultPromo from '../pages/SearchResultPromo';
import Dashboard from '../pages/Dashboard';
import ProfileForm from '../form/ProfileForm';
import BookingHistory from '../pages/BookingHistory';
import Transaction from '../pages/Transaction';
import ChangePassword from '../pages/ChangePassword';
import SearchResultBus from '../pages/SearchResultBus';
import BusDetailPage from '../pages/BusDetailPage';
import SearchResultInternational from '../pages/SearchResultInternational';
import SearchResultHolidays from '../pages/SearchResultHolidays';
import HolidaysDetailPage from '../pages/HolidaysDetailPage';
import Ticket from './resuableComponents/Ticket';

const MainRouter = () => {
	return (
		<div>
			<Routes>
				<Route path='/' exact element={<LandingPage />} />
				<Route path='/searchresult' exact element={<SearchResultPage />} />
				<Route
					path='/searchresultpromo'
					exact
					element={<SearchResultPromo />}
				/>
				<Route path='/searchresultbus' exact element={<SearchResultBus />} />
				<Route
					path='/searchresultholidays'
					exact
					element={<SearchResultHolidays />}
				/>
				<Route
					path='/searchresultroundtrip'
					exact
					element={<SearchResultRoundtripPage />}
				/>
				<Route
					path='/searchresultinternational'
					exact
					element={<SearchResultInternational />}
				/>
				<Route path='/flightbooking' exact element={<FlightDetailPage />} />
				<Route path='/holidaysbooking' exact element={<HolidaysDetailPage />} />
				<Route
					path='/confirmbooking'
					exact
					element={<FlightConfirmDetailPage />}
				/>
				<Route path='/busbooking' exact element={<BusDetailPage />} />
				<Route
					path='/dashboard'
					element={
						<>
							<Layout title={'Overview'}>
								<Dashboard />
							</Layout>
						</>
					}></Route>
				<Route
					path='/profile'
					element={
						<>
							<Layout title={'Profile'}>
								<ProfileForm />
							</Layout>
						</>
					}></Route>
				<Route
					path='/ticket'
					element={
						<>
							<Layout title={'Ticket'}>
								<Ticket />
							</Layout>
						</>
					}></Route>
				<Route
					path='/changepassword'
					element={
						<>
							<Layout title={'Change Password'}>
								<ChangePassword />
							</Layout>
						</>
					}></Route>{' '}
				<Route
					path='/transaction'
					element={
						<>
							<Layout title={'Transaction History'}>
								<Transaction />
							</Layout>
						</>
					}></Route>
				<Route
					path='/booking'
					element={
						<>
							<Layout title={'Transaction History'}>
								<BookingHistory />
							</Layout>
						</>
					}></Route>
				<Route path='*' exact element={<h1>Page Not found</h1>} />
			</Routes>
		</div>
	);
};

export default MainRouter;
